import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useResults } from '@/scopes/search/search/domain/hooks'
import { space } from '@sunwebgroup/ui-components'
import { Button, Sheet, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import { ProductCardCompact } from './ProductCardCompact'

const FooterButton = styled(Button)`
  flex-basis: 50%;
`

const SheetFooter = styled(Sheet.Footer)`
  flex-direction: row;
  gap: ${space('primitives_space_8')};
`

const ContentText = styled(Typography)`
  margin-top: ${space('primitives_space_32')};
`
export function LogInSheet({ productId, onClose }: { productId: number, onClose: () => void }): React.ReactElement {
  const intl = useIntl()
  const { results } = useResults()
  const loginUrl = useConfiguration('links.login')
  const createAccountUrl = useConfiguration('links.createAccount')

  const product = React.useMemo(() => results.find(({ id }) => id === productId), [results, productId])

  return (
    <Sheet.Body side="right">
      <Sheet.Header titleLabel={intl.formatMessage({ id: 'favorite_login_modal_title' })} closeLabel={intl.formatMessage({ id: 'close' })} />
      <Sheet.Content>
        {product && (
          <ProductCardCompact
            id={product.id}
            accommodationId={product.id}
            imageSources={product.images}
            href={product.url}
            name={product.name}
            userRating={product.userRating}
            userRatingText={product.userRatingText}
            locations={product.locations}
            rating={product.rating ?? 0}
          />
        )}
        <ContentText $variant="body-l-regular-snug" as="p">{intl.formatMessage({ id: 'favorite_login_modal_text' })}</ContentText>
      </Sheet.Content>
      <SheetFooter isFixed>
        <FooterButton
          $type="secondary"
          onClick={() => {
            window.location.href = `${createAccountUrl}&returnurl=${encodeURIComponent(document.URL)}`
            onClose()
          }}
        >
          {intl.formatMessage({ id: 'favorite_login_modal_secondary_action_text' })}
        </FooterButton>
        <FooterButton
          $type="primary"
          onClick={() => {
            window.location.href = `${loginUrl}?returnurl=${encodeURIComponent(document.URL)}`
            onClose()
          }}
        >
          {intl.formatMessage({ id: 'favorite_login_modal_primary_action_text' })}
        </FooterButton>
      </SheetFooter>
    </Sheet.Body>
  )
}
